import { MenuItem } from "@mui/material";
import { DocumentType } from "../types";

const DocumentTypeList = () =>  Object.entries(DocumentType)
  .map(([key, dt]) => <MenuItem key={key} value={dt}>{dt}</MenuItem>);

export default DocumentTypeList;